module.exports = __webpack_public_path__ + "img/198.d09589ef.jpg";